import { ReactNode } from "react";
import classNames from "classnames";
import { IoMdInformationCircleOutline } from "react-icons/io";
import styles from "./style.module.scss";
import { CardVariant } from "types";
import VLTooltip from "views/uikit/VLTooltip";

export interface HeaderTitleProps {
  prefix: ReactNode;
  suffix?: { tooltipText: string; icon: ReactNode };
  debugInfo?: string;
  cardVariant: CardVariant;
  title: string | ReactNode;
}

const HeaderTitle = ({
  prefix,
  suffix,
  title,
  debugInfo,
  cardVariant,
}: HeaderTitleProps) => {
  const headerTitleClassnames = classNames(styles.headerTitle, {
    [styles.exportHeaderTitle]: cardVariant === CardVariant.SELECTED,
    [styles.similarityHeaderTitle]: cardVariant === CardVariant.VERTEX,
  });

  const renderDebugInfoIcon = () => {
    if (debugInfo) {
      return (
        <>
          <VLTooltip title={debugInfo}>
            <div data-testid={"debug-icon"} className={styles.debugInfoTooltip}>
              <IoMdInformationCircleOutline size={"1em"} />
            </div>
          </VLTooltip>
        </>
      );
    }
    return <noscript />;
  };

  return (
    <div className={headerTitleClassnames} data-testid={"title-header"}>
      <div className={styles.titleIcon}>{prefix}</div>
      <div
        className={styles.titleContainer}
        title={typeof title === "string" ? title : ""}
      >
        {title}
      </div>
      <div className={styles.debugIcon}>{renderDebugInfoIcon()}</div>
      {suffix && <CardHeaderSuffix {...suffix} />}
    </div>
  );
};

export const CardHeaderSuffix = ({
  icon,
  tooltipText,
}: {
  tooltipText: string;
  icon: ReactNode;
}) => (
  <VLTooltip
    title={<div className={styles.suffixTooltipContent}>{tooltipText}</div>}
  >
    <div>{icon}</div>
  </VLTooltip>
);

export default HeaderTitle;
